import * as oauth from 'oauth4webapi';

const initAuthConfig = async (
  data?: string,
  redirectUrl?: string,
): Promise<oauth.AuthorizationServer> => {
  const CODE_CHALLENGE_METHOD = 'S256';
  const CODE_VERIFIER = oauth.generateRandomCodeVerifier();
  const CODE_CHALLENGE = await oauth.calculatePKCECodeChallenge(CODE_VERIFIER);
  const url = new URL(window.location.href);
  if (data) {
    url.searchParams.set('data', data);
  }
  let reUrl = url.pathname + url.search + url.hash;
  if (redirectUrl) {
    reUrl = redirectUrl;
  }
  const stateObject = {
    data: oauth.generateRandomState(),
    redirectUrl: reUrl,
  };
  const STATE = JSON.stringify(stateObject);
  // const STATE = oauth.generateRandomState();
  localStorage.setItem('code_verifier', CODE_VERIFIER);
  localStorage.setItem('state', STATE);
  const config: oauth.AuthorizationServer = {
    issuer: process.env.REACT_APP_ISSUER as string,
    authorization_endpoint: process.env.REACT_APP_AUTHORIZATION_ENDPOINT,
    token_endpoint: process.env.REACT_APP_TOKEN_ENDPOINT,
    scope: process.env.REACT_APP_SCOPE,
    state: STATE,
    code_challenge_method: CODE_CHALLENGE_METHOD,
    code_challenge: CODE_CHALLENGE,
  };
  return config;
};

const getAuthUrl = async (
  login_hint?: string,
  data?: string,
  redirectUrl?: string,
): Promise<string> => {
  const authConfig = await initAuthConfig(data, redirectUrl);
  const authorizationUrl = new URL(process.env.REACT_APP_AUTHORIZATION_ENDPOINT!);
  sessionStorage.removeItem('tokenProcess');
  authorizationUrl.searchParams.set('client_id', process.env.REACT_APP_CLIENT_ID as string);
  authorizationUrl.searchParams.set('redirect_uri', process.env.REACT_APP_REDIRECT_URI as string);
  authorizationUrl.searchParams.set('response_type', 'code');
  authorizationUrl.searchParams.set('state', authConfig.state! as string);
  authorizationUrl.searchParams.set('scope', process.env.REACT_APP_SCOPE as string);
  authorizationUrl.searchParams.set('code_challenge', authConfig.code_challenge! as string);
  authorizationUrl.searchParams.set(
    'code_challenge_method',
    authConfig.code_challenge_method! as string,
  );
  if (login_hint) {
    authorizationUrl.searchParams.set('login_hint', login_hint);
  }
  return authorizationUrl.href;
};

export default getAuthUrl;
